import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { CERTIFICATIONS } from "@/lib/sipl-content";

export default function Certifications() {
  return (
    <section
      id="certifications"
      data-testid="certifications-section"
      className="py-16 md:py-20 bg-sipl-bg border-y border-sipl-line"
    >
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="text-sm uppercase tracking-[0.22em] text-sipl-secondary mb-3">
            Certifications & Compliance
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-sipl-primary font-medium">
            Compliant. Audited. Investor-ready.
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {CERTIFICATIONS.map((c, idx) => (
            <motion.div
              key={c.label}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: idx * 0.06 }}
              data-testid={`cert-${idx}`}
              className="sipl-card p-5 lg:p-6 flex flex-col items-start gap-3"
            >
              <div className="w-10 h-10 rounded-md bg-sipl-secondary/10 flex items-center justify-center">
                <ShieldCheck className="w-5 h-5 text-sipl-secondary" />
              </div>
              <div className="font-heading text-sipl-primary text-base font-medium">
                {c.label}
              </div>
              <div className="text-xs text-sipl-fg/65 leading-relaxed">
                {c.desc}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
